import { render, staticRenderFns } from "./homeDashboardAcquisitionManagement.vue?vue&type=template&id=40b23dfb&scoped=true"
import script from "./homeDashboardAcquisitionManagement.vue?vue&type=script&lang=js"
export * from "./homeDashboardAcquisitionManagement.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardAcquisitionManagement.vue?vue&type=style&index=0&id=40b23dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b23dfb",
  null
  
)

export default component.exports